module.exports = __webpack_public_path__ + "img/slider-dark-01.5f3596d4.png";